/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { StyleSheet, View, Dimensions } from 'react-native';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import PropTypes from 'prop-types';

const propTypes = {
  page: PropTypes.number,
  totalPage: PropTypes.number,
};

const defaultProps = {
  page: 1,
  totalPage: 1,
};
const decrement = isWeb ? 430 : 0;

const fullWidth = Dimensions.get('window').width - 10;

const ProgressBar = (props) => {
  const { testID, page = 1, totalPage = 1 } = props;

  return (
    <View
      testID={testID}
      style={{ width: '100%', backgroundColor: Colors.white }}>
      <View style={styles.progress}>
        <View
          style={[
            styles.progress,
            styles.progressActive,
            { width: (fullWidth - decrement) / (totalPage / page) },
          ]}></View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  progress: {
    position: 'relative',
    width: fullWidth - decrement,
    height: 7,
    borderRadius: 10,
    backgroundColor: Colors.grey0,
    marginVertical: 5,
    marginHorizontal: 5,
  },
  progressActive: {
    backgroundColor: Colors.blue0,
    position: 'absolute',
    top: -5,
    left: -5,
  },
});

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

export default ProgressBar;
